const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp'];

export const INVALID_FILE_TYPE_MESSAGE =
  'Invalid file type. Allowed formats: JPG, JPEG, PNG, WEBP.';

export function isValidImageExtension(file: File): boolean {
  const ext = file.name.split('.').pop()?.toLowerCase() ?? '';
  return ALLOWED_EXTENSIONS.includes(ext);
}

export function getFirstInvalidFile(files: FileList | File[]): File | null {
  const list = Array.from(files);
  return list.find((f) => !isValidImageExtension(f)) ?? null;
}
